<div class="bottom_wrapper">
  <div class="user_info_field" style="display: flex; flex-direction: row; width: 100%; font-family: sans-serif; color: black; background-color: #E0F7FA; border-top: 1px #E0E0E0 solid" *ngIf="coreConfiguration.isOnline && coreConfiguration.newVersionAvailable">
    <mat-icon style="font-size: 24px">error_outline</mat-icon>
    <div style="display: flex; flex-direction: column; cursor: pointer" (click)="updateVersion()">
      <span style="margin-bottom: 0.5em;" i18n>Ny versjon tilgjengelig</span>
      <span style="color: #E64A19; text-decoration: underline; font-weight: bold" i18n>Oppdater til ny versjon</span>
    </div>
  </div>
  <div class="user_info_field" style="width: 100%; font-family: sans-serif; color: white; background-color: #E64A19" *ngIf="!coreConfiguration.isOnline">
    <mat-icon>error_outline</mat-icon>
    <span style="text-align: center; margin: auto 0" i18n>Sjekk nettverkstilkobling</span>
  </div>
  <div class="user_info">
    <span class="user_info_field">
      <mat-icon>person</mat-icon>
      {{username}}
    </span>
    <span class="user_info_field">
      <mat-icon>business</mat-icon>
      {{companyName}}
    </span>
    <a (click)="onLogout.emit()" class="user_info_field">
      <mat-icon>lock_open</mat-icon>
      <span i18n>Logg ut</span></a>
  </div>
</div>
